import { render, staticRenderFns } from "./boxplot.vue?vue&type=template&id=2ff72bfb&scoped=true"
import script from "./boxplot.vue?vue&type=script&lang=js"
export * from "./boxplot.vue?vue&type=script&lang=js"
import style0 from "./boxplot.vue?vue&type=style&index=0&id=2ff72bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff72bfb",
  null
  
)

export default component.exports